import { MoveProductsSelectorMolecule } from '../../../components/molecules/MoveProductsSelector.molecule'
import { useMoveOptions } from './MoveOptions.hook'
import { Icons, PageContentAtom, ToolbarMolecule } from '@justomx/atlas-components'
import { useTranslation } from 'react-i18next'

export const MoveOptionsPage = () => {
  const {
    actions,
    options,
    origin
  } = useMoveOptions()
  const { t } = useTranslation('global')

  return (<>
    <ToolbarMolecule
      title={origin}
      actionIcon={Icons.ArrowBack}
      onAction={actions.back}
    />
    <PageContentAtom>
      {options.map((it) => {
        return (
          <MoveProductsSelectorMolecule
            key={it}
            type={it}
            onClick={actions.onClickGo(it)}
            items={t(`reverse-logistics.move-options.${it}.items`, {
              returnObjects: true })} 
          />
        )
      })}
    </PageContentAtom>
  </>)
}
